export default __webpack_public_path__ + "static/media/Myracle tutorial_v1.0_ITA_low quality.548fd93e.mp4";